var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcn6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#16DBC7;}\n\t.st1{display:none;}\n\t.st2{display:inline;}\n\t.st3{font-family:'MyriadPro-Regular';}\n\t.st4{font-size:21.22px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20,
    cy: 20.4,
    r: 13
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_8_-_copie_6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.5,13.4v1.2l-6,12.6h-1.9l6-12.2v0h-6.7v-1.5H24.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.4,14.7c-0.4,0-0.9,0-1.4,0.1c-2.9,0.5-4.5,2.6-4.8,4.9h0.1c0.7-0.9,1.8-1.6,3.3-1.6c2.4,0,4.2,1.8,4.2,4.5 c0,2.5-1.7,4.9-4.6,4.9c-3,0-4.9-2.3-4.9-5.9c0-2.7,1-4.9,2.3-6.2c1.1-1.1,2.7-1.8,4.4-2c0.6-0.1,1-0.1,1.4-0.1V14.7z M22.9,22.7 c0-2-1.1-3.2-2.8-3.2c-1.1,0-2.2,0.7-2.7,1.7c-0.1,0.2-0.2,0.5-0.2,0.8c0,2.3,1.1,3.9,3,3.9C21.8,26,22.9,24.7,22.9,22.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.7,15h-5.3L18,18.5c0.3,0,0.6-0.1,1.1-0.1c1.1,0,2.1,0.2,3,0.7c1.1,0.6,2,1.8,2,3.5c0,2.7-2.1,4.7-5.1,4.7 c-1.5,0-2.8-0.4-3.4-0.8l0.5-1.4c0.6,0.3,1.7,0.8,3,0.8c1.8,0,3.3-1.1,3.3-3c0-1.8-1.2-3.1-4-3.1c-0.8,0-1.4,0.1-1.9,0.1l0.9-6.6 h6.6V15z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.3,27.2v-3.8h-6.4v-1.2l6.2-8.8h2V22H25v1.5H23v3.8H21.3z M21.3,22v-4.6c0-0.7,0-1.4,0.1-2.2h-0.1 c-0.4,0.8-0.8,1.4-1.1,2L16.8,22v0H21.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16,25.1c0.5,0.3,1.8,0.9,3.1,0.9c2.4,0,3.1-1.5,3.1-2.7c0-1.9-1.8-2.8-3.6-2.8h-1v-1.4h1 c1.4,0,3.1-0.7,3.1-2.3c0-1.1-0.7-2.1-2.4-2.1c-1.1,0-2.2,0.5-2.8,0.9L16,14.3c0.7-0.5,2.1-1.1,3.6-1.1c2.7,0,3.9,1.6,3.9,3.3 c0,1.4-0.8,2.6-2.5,3.2v0c1.7,0.3,3.1,1.6,3.1,3.5c0,2.2-1.7,4.1-5,4.1c-1.5,0-2.9-0.5-3.6-0.9L16,25.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.5,27.2v-1.1l1.5-1.4c3.5-3.4,5.1-5.1,5.1-7.2c0-1.4-0.7-2.7-2.7-2.7c-1.3,0-2.3,0.6-2.9,1.2l-0.6-1.3 c1-0.8,2.3-1.4,3.9-1.4c3,0,4.2,2,4.2,4c0,2.5-1.8,4.6-4.8,7.4l-1.1,1v0h6.2v1.5H15.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.6,15.2L19.6,15.2l-2.4,1.3L16.8,15l3-1.6h1.6v13.8h-1.8V15.2z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_8_-_copie_7",
    className: "st1"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 14.5566 27.2285)",
    className: "st2 st3 st4"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 14.5566 27.2285)",
    className: "st2 st3 st4"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 14.5566 27.2285)",
    className: "st2 st3 st4"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 14.5566 27.2285)",
    className: "st2 st3 st4"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 14.5566 27.2285)",
    className: "st2 st3 st4"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 14.5566 27.2285)",
    className: "st2 st3 st4"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 14.5566 27.2285)",
    className: "st2 st3 st4"
  }, "1"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn6);
export default __webpack_public_path__ + "static/media/icn-6.37ce553010d8c41f4881b5e4e8272b33.svg";
export { ForwardRef as ReactComponent };